/*
 * Tiger Flags — a tag do Google do <head> (layout/theme.liquid) segue o consentimento de análise.
 *
 * O <head> só enfileira os comandos (consent default negado com wait_for_update, js, config) no dataLayer; nada é
 * enviado e nenhum cookie é criado enquanto o gtag.js não carrega. Este script carrega o gtag.js só quando a Customer
 * Privacy API do Shopify diz 'permitido' (aceitou, ou a loja não exige consentimento nesta região), antes manda o
 * consent update com a escolha (analytics_storage; ad_* pelo marketing). Recusa, API ausente ou erro: o gtag.js não
 * carrega (sem envio, sem cookie novo, sem atualizar cookie antigo). Revogação na mesma página: consent update negado e
 * ga-disable no GA4, para parar envios e cookies até a página seguinte, que já abre sem o gtag.js.
 * Mesma regra de estado de assets/tiger-ga4.js (Core.estadoConsentimento).
 */
(function (root) {
  'use strict';

  var Core = {};

  Core.estado = function (cp) {
    try {
      if (!cp || typeof cp.analyticsProcessingAllowed !== 'function') return 'desconhecido';
      if (cp.analyticsProcessingAllowed() === true) return 'permitido';
      var v = typeof cp.currentVisitorConsent === 'function' ? cp.currentVisitorConsent() : null;
      return v && v.analytics === 'no' ? 'negado' : 'desconhecido';
    } catch (e) {
      return 'desconhecido';
    }
  };

  /** Sinais do Consent Mode: análise pelo estado; anúncios só com análise E marketing permitidos. */
  Core.sinais = function (cp, estado) {
    var a = estado === 'permitido';
    var m = false;
    if (a) {
      try {
        m = typeof cp.marketingAllowed === 'function' && cp.marketingAllowed() === true;
      } catch (e) {
        m = false;
      }
    }
    var ad = m ? 'granted' : 'denied';
    return { analytics_storage: a ? 'granted' : 'denied', ad_storage: ad, ad_user_data: ad, ad_personalization: ad };
  };

  /**
   * Controle da página: env = { gtag, carregar (insere o gtag.js), win, ids (GA4 para o ga-disable) }.
   * aplicar(cp) a cada leitura do consentimento; carrega uma vez só.
   */
  Core.criar = function (env) {
    var carregado = false;
    function desliga(on) {
      for (var i = 0; i < env.ids.length; i++) env.win['ga-disable-' + env.ids[i]] = on;
    }
    return {
      aplicar: function (cp) {
        var e = Core.estado(cp);
        if (e === 'permitido') {
          env.gtag('consent', 'update', Core.sinais(cp, e));
          desliga(false);
          if (!carregado) {
            carregado = true;
            env.carregar();
          }
        } else if (carregado) {
          env.gtag('consent', 'update', Core.sinais(cp, 'negado'));
          desliga(true);
        }
        return e;
      },
      carregado: function () {
        return carregado;
      },
    };
  };

  if (typeof module !== 'undefined' && module.exports) {
    module.exports = Core;
    return;
  }

  var el = document.currentScript;
  var tag = el && el.getAttribute('data-gtag-id');
  if (!tag || typeof root.gtag !== 'function' || root.__tigerGtag) return;
  root.__tigerGtag = true;
  var ga4 = el.getAttribute('data-ga4-id');
  var ctl = Core.criar({
    gtag: root.gtag,
    win: root,
    ids: ga4 ? [ga4] : [],
    carregar: function () {
      var s = document.createElement('script');
      s.async = true;
      s.src = 'https://www.googletagmanager.com/gtag/js?id=' + encodeURIComponent(tag);
      document.head.appendChild(s);
    },
  });
  function ler() {
    ctl.aplicar(root.Shopify && root.Shopify.customerPrivacy);
  }
  document.addEventListener('visitorConsentCollected', ler);
  var sh = root.Shopify;
  if (sh && sh.customerPrivacy) {
    ler();
  } else if (sh && typeof sh.loadFeatures === 'function') {
    // Sem banner na página a API não vem carregada: carrega (documentado pelo Shopify) para saber o estado.
    sh.loadFeatures([{ name: 'consent-tracking-api', version: '0.1' }], ler);
  }
})(typeof window !== 'undefined' ? window : this);
